import { render, staticRenderFns } from "./ReservationsAdminCalendar.vue?vue&type=template&id=61fa4766&scoped=true&"
import script from "./ReservationsAdminCalendar.vue?vue&type=script&lang=js&"
export * from "./ReservationsAdminCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsAdminCalendar.vue?vue&type=style&index=0&id=61fa4766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa4766",
  null
  
)

export default component.exports